import { Category } from "@/payload-types";


interface CategoriesWithChildren extends Category {
  children?: Category[]
}

export function buildCategoryHierarchy( input: Category[]): CategoriesWithChildren[] {
  const map: { [key: string]: CategoriesWithChildren } = {};
  const output: CategoriesWithChildren[] = [];

  // First pass: Create a map of all items by their id
  input.forEach(item => {
    map[item.id] = { ...item };
  });

  // Second pass: Build the hierarchy
  input.forEach(item => {
    if (!item.parent) {
      output.push(map[item.id]);
      return; // Early return for items without a parent
    }

    const parentId = typeof item.parent === "object" ? item.parent.id : item.parent;
    const parent = map[parentId];
    if (!parent) return; // Early return if parent doesn't exist in the map

    if (!parent.children) {
      parent.children = [];
    }
    parent.children.push(map[item.id]);
  });

  return output;
}
